
import React from 'react';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { useMobileMenu } from './MobileMenuContext';

interface MobileUserProfileProps {
  user: any;
  getUserInitials: () => string;
}

const MobileUserProfile = ({ user, getUserInitials }: MobileUserProfileProps) => {
  const { userName, isAdmin } = useMobileMenu();

  if (!user) return null;

  return (
    <div className="p-6 bg-muted/30">
      <div className="flex items-center gap-3">
        <Avatar className="h-12 w-12">
          <AvatarFallback className="bg-gradient-to-r from-primary to-primary/80 text-white text-lg">
            {getUserInitials()}
          </AvatarFallback>
        </Avatar>
        <div className="flex flex-col">
          {userName && (
            <p className="font-semibold text-foreground">{userName}</p>
          )}
          <p className="text-sm text-muted-foreground truncate max-w-[200px]">
            {user?.email}
          </p>
          {isAdmin && (
            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-primary/10 text-primary mt-1 w-fit">
              Admin
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default MobileUserProfile;
